export default function validateField(field) {
  if (field.length < 4) {
    return 'must have at least 4 letters';
  }
}
